module.exports = __webpack_public_path__ + "static/logo_google_for_startups@3x-f705d6ffc6938803243664abaa6a52f4.png";